import styled from "styled-components"

import { minWidth, eq, when } from "utils"

import Icon from "icons"
import CloudinaryImage from "components/cloudinary-image"
import Video from "components/video"

export const Container = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem;
  padding-bottom: 3rem;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto;

    ${eq("priority", 2)`
      padding-bottom: 0;
    `}

    ${eq("priority", 3)`
      padding-bottom: 0;
    `}
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
  `}
`

export const ProductWrapper = styled.div`
  min-width: 25.8rem;
  padding: 1.3rem 1.5rem 2.2rem;
  background: rgba(239, 238, 230, 1);

  ${minWidth.tablet`
    min-width: unset;
    padding: 0 0 0 2rem;
    display: inline-block;
    background: none;

    ${eq("priority", 1)`
      display: flex;
      justify-content: center;
      flex-direction: row-reverse;
    `}

    ${eq("priority", 2)`
      width: 23.2rem;
      min-width: 25.8rem;
      margin-right: 3.2rem;
      padding: 1.3rem 1.5rem 1.5rem;
      float: left;
      background: rgba(239,238,230,1);
    `}

    ${eq("priority", 3)`
      width: 23.2rem;
      margin-left: 3.2rem;
      float: right;
    `}
  `}
`

export const Description = styled.div`
  display: block;
  margin-bottom: 1.6rem;
  line-height: 1.5;
  * {
    margin: 0;
  }
`

export const ProductHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`

export const ProductTestiomonalHeader = styled.div``

export const ProductHeadline = styled.h3`
  margin-bottom: 0.8rem;
  font-size: 2.1rem;
  line-height: 1.5;
  font-weight: 500;

  ${minWidth.tablet`
    ${eq("priority", 1)`
      margin-top: 2.2rem;
      font-size: 3rem;
    `}
  `}
`

export const ProductTestimonialHeadline = styled.h3`
  font-style: normal;
  font-weight: 500;
  font-size: 2.4rem;
  line-height: 128%;
  margin-bottom: 1.3rem;
  color: #555e65;
  p {
    margin: 0;
    padding: 0;
  }

  em {
    color: #ec5d2a;
    font-style: normal;
  }
`

export const ClassImage = styled(CloudinaryImage)`
  overflow: unset;
  height: unset;
  position: unset;
  picture {
    img {
      width: 100%;
      position: unset;
      top: unset;
      left: unset;
      height: unset;
    }
  }
  ${minWidth.tablet`
    ${eq("priority", 1)`
      width: 25.6rem;
      margin-right: 2.5rem;

      img {
        min-width: 25.6rem !important;
        min-height: 25.6rem !important;
        border-radius: 1rem;
      }
    `}
  `}
`

export const InfoWrapper = styled.div`
  ${minWidth.tablet`
    ${eq("priority", 1)`
      width: 100%;
    `}
  `}
`

export const MediaWrapper = styled.div`
  ${minWidth.tablet`
    ${eq("priority", 1)`
      width: 52%;
    `}
  `}
`

export const VideoContainer = styled(Video)`
  ${minWidth.tablet`
    width: 26.5rem;
    margin-right: 2.5rem;
  `}
`

export const Button = styled.button`
  margin: 2.2rem auto 0;
  padding: 1rem 3rem;
  border: 0;
  border-radius: 2.1rem;
  display: block;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.092rem;
  text-transform: uppercase;
  background-color: ${(props) => props.theme.colors.productsOrange};
  color: white;

  ${eq("custom", true)`
    background-color: ${(props) => props.theme.colors.purpleMindfulness};
  `}

  ${eq("isClass", true)`
    background-color: ${(props) => props.theme.colors.classesTeal};
  `}

  ${minWidth.tablet`
    margin: 2.2rem 0 0;

    ${eq("priority", 1)`
      display: none;
    `}
  `}
`

export const ButtonOne = styled.button`
  margin: 2.2rem auto 0;
  padding: 1rem 3rem;
  border: 0;
  border-radius: 2.1rem;
  display: none;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.092rem;
  text-transform: uppercase;
  background-color: ${(props) => props.theme.colors.productsOrange};
  color: white;

  ${eq("custom", true)`
    background-color: ${(props) => props.theme.colors.purpleMindfulness};
  `}

  ${eq("isClass", true)`
    background-color: ${(props) => props.theme.colors.classesTeal};
  `}

  ${minWidth.tablet`
    margin: 2.2rem 0 0;

    ${eq("priority", 1)`
      display: block;
    `}
  `}
`

export const ClassShortIcon = styled(Icon)`
  color: ${(props) => props.theme.colors.productsOrange};
  display: inline-block;
  width: 1.7rem;
  height: 2rem;
  line-height: 1.5;

  /* IE 11 */
  max-height: 2rem;
  ${eq("priority", 1)`
    display:none;
  `}
`

export const TestimonialAttribution = styled.div`
  display: none;

  ${eq("priority", 1)`
    display: block;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 128%;
    color: #222222;
  `}

  p {
    margin: 0;
    padding: 0;
  }
`

export const Stars = styled.div`
  margin-top: 0.9rem;
  margin-bottom: 1.5rem;

  ${minWidth.tablet`
    margin-bottom: 0;
  `}

  .rating-stars {
    position: relative;
    vertical-align: middle;
    display: inline-block;
    color: #cccccc;
    overflow: hidden;
  }

  .rating-stars__top {
    position: absolute;
    top: 0;
    left: 0;
    white-space: nowrap;
    color: #222222;
    overflow: hidden;
  }
`
export const StarsContainer = styled.div`
  display: flex;
  align-items: center;
  p {
    color: #222;
    font-weight: 500;
    margin: 0.25rem 0 2rem 1rem;
  }
`
